export const addNonProdDisplayName = (Component: { displayName?: string }, displayName: string): void => {
    if (process.env.NODE_ENV !== "production") {
        Component.displayName = displayName;
    }
};
